import { render, staticRenderFns } from "./ServiceSequenceBadge.vue?vue&type=template&id=6a8d5737&scoped=true"
import script from "./ServiceSequenceBadge.vue?vue&type=script&lang=js"
export * from "./ServiceSequenceBadge.vue?vue&type=script&lang=js"
import style0 from "./ServiceSequenceBadge.vue?vue&type=style&index=0&id=6a8d5737&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8d5737",
  null
  
)

export default component.exports